/**
 * Entry point: bundles SpacetimeDB SDK + bindings + Network adapter
 * into a single script that exposes window.Network for main.js.
 */
import { Network } from './spacetimedb-network';
import { createProceduralMapRuntime, isProceduralManifest } from './procedural-map';
import { ARCHETYPES, ARMY_POINT_BUDGET, DEFAULT_RULESET, MAX_ARMY_SIZE } from './game-config';
import { GlobalCampaignClient } from './global-campaign-client';

declare global {
    interface Window {
        GlobalCampaignClient: typeof GlobalCampaignClient;
    }
}

window.GlobalCampaignClient = GlobalCampaignClient;

// Expose globally so main.js (non-module script) can use it
(window as any).Network = Network;
(window as any).WarlordsGameConfig = {
    archetypes: ARCHETYPES,
    armyBudget: ARMY_POINT_BUDGET,
    maxArmySize: MAX_ARMY_SIZE,
    defaultRuleset: DEFAULT_RULESET,
};
(window as any).ProceduralMapRuntime = {
    createProceduralMapRuntime,
    isProceduralManifest,
};
